import { isDashboardAppearance } from "./components/dashboardAppearance";
import React, { useEffect } from "react";
import lazyPage from "./components/lazyPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import ChatWidget from "./components/ChatWidget";

import ProtectedRoute from "./dashboard/ProtectedRoute";

// import ClientProfile from "./dashboard/UserProfile";

// import CreateMeeting from "./dashboard/CreateMeetings";

import FeatureRouteProtection from "./dashboard/FeatureRouteProtection";
import Unauthorized from "./components/Unauthorized";

import { MasterAuthProvider } from "./masterdashboard/MasterAuthContext";
import MasterProtectedRoute from "./masterdashboard/MasterProtectedRoute";

import { AuthContext } from "./components/AuthContext";
import { useContext } from "react";
import { useBranding } from "./components/usebranding";

import ScrollToTop from "./components/ScrollToTop";

import TenantAccessBoundary from './components/TenantAccessBoundary';

const MarketplaceLayout = lazyPage(() => import("./pages/MarketPlaceLayout"));
const HomePage = lazyPage(() => import("./pages/Home"));
const AboutPage = lazyPage(() => import("./pages/About"));
const ProductsPage = lazyPage(() => import("./pages/Products"));
const ProductDetails = lazyPage(() => import("./pages/ProductsDetails"));
const Contact = lazyPage(() => import("./pages/Contact"));
const AdminRegister = lazyPage(() => import("./pages/AdminRegister"));
const AdminLoginPage = lazyPage(() => import("./pages/AdminLogin"));
const UserLoginPage = lazyPage(() => import("./pages/UserLogin"));
const Index = lazyPage(() => import("./dashboard/index"));
const Tasks = lazyPage(() => import("./dashboard/Tasks"));
const Certificates = lazyPage(() => import("./dashboard/Certificates"));
const Notifications = lazyPage(() => import("./dashboard/Notifications"));
const Clients = lazyPage(() => import("./dashboard/Clients"));
const Partners = lazyPage(() => import("./dashboard/Partners"));
const Payments = lazyPage(() => import("./dashboard/Payments"));
const Students = lazyPage(() => import("./dashboard/Students"));
const AdminInvoice = lazyPage(() => import("./dashboard/Invoice"));
const Attendance = lazyPage(() => import("./dashboard/Attendance"));
const TenantCourseDetailsPage = lazyPage(() => import("./dashboard/CourseDetailsPage"));
const Courses = lazyPage(() => import("./dashboard/Courses"));
const Staff = lazyPage(() => import("./dashboard/Staff"));
const Branches = lazyPage(() => import("./dashboard/Branches"));
const PartnerHome = lazyPage(() => import("./partnersdashboard/Index"));
const PartnerNotifications = lazyPage(() => import("./partnersdashboard/Notifications"));
const PartnerPayments = lazyPage(() => import("./partnersdashboard/Payments"));
const PartnerProfile = lazyPage(() => import("./partnersdashboard/Profile"));
const StaffAttendance = lazyPage(() => import("./dashboard/StaffAttendance"));
const AdminProfile = lazyPage(() => import("./dashboard/Profile"));
const Appointments = lazyPage(() => import("./dashboard/Appointments"));
const Products = lazyPage(() => import("./dashboard/Products"));
const UserProfile = lazyPage(() => import("./partnersdashboard/UserProfile"));
const UserProfileService = lazyPage(() => import("./partnersdashboard/UserProfileService"));
const AddLead = lazyPage(() => import("./dashboard/AddLead"));
const LeadFormBuilder = lazyPage(() => import("./dashboard/LeadFormBuilder"));
const ClientProfile = lazyPage(() => import("./dashboard/ClientProfile"));
const Registrations = lazyPage(() => import("./dashboard/Registrations"));
const PublicRegistration = lazyPage(() => import('./pages/PublicRegistration'));
const MasterLayout = lazyPage(() => import("./masterdashboard/MasterLayout"));
const Features = lazyPage(() => import("./masterdashboard/Features"));
const Plans = lazyPage(() => import("./masterdashboard/Plans"));
const ApprovalInboxPage = lazyPage(() => import("./masterdashboard/ApprovalInbox").then(module => ({default:module.ApprovalInboxPage})));
const Home = lazyPage(() => import("./masterdashboard/Home"));
const MasterLogin = lazyPage(() => import("./pages/MasterLogin"));
const TenantProfile = lazyPage(() => import("./masterdashboard/TenantProfile"));
const InvitationCatalog = lazyPage(() => import('./masterdashboard/InvitationCatalog'));
const SystemHealth = lazyPage(() => import('./masterdashboard/SystemHealth'));
const Analytics = lazyPage(() => import("./masterdashboard/Analytics"));
const SearchProducts = lazyPage(() => import("./dashboard/SearchProducts"));
const ProductDetail = lazyPage(() => import("./dashboard/ProductDetailPage"));
const BNIPage = lazyPage(() => import("./dashboard/BNIPage"));
const ProfitLoss = lazyPage(() => import("./dashboard/Accounts/Profitloss"));
const Ledger = lazyPage(() => import("./dashboard/Accounts/Generalledger"));
const Balancesheet = lazyPage(() => import("./dashboard/Accounts/BalanceSheet"));
const Expenses = lazyPage(() => import("./dashboard/Accounts/Expenses"));
const Tax = lazyPage(() => import("./dashboard/Accounts/Tax"));
const AccountReports = lazyPage(() => import("./dashboard/Accounts/Reports"));
const Analyticsmain = lazyPage(() => import("./dashboard/Analytics"));
const AssociatePartners = lazyPage(() => import("./dashboard/AssociatePartners"));
const Departments = lazyPage(() => import("./dashboard/Departments"));
const Positions = lazyPage(() => import("./dashboard/Positions"));
const Roles = lazyPage(() => import("./dashboard/Roles"));
const Calllog = lazyPage(() => import("./dashboard/Calllog"));
const MyReferrals = lazyPage(() => import("./dashboard/MyReferrals"));
const IncomingReferrals = lazyPage(() => import("./dashboard/IncomingReferrals"));
const ClientEnrollments = lazyPage(() => import("./dashboard/ClientEnrollments"));
const AssignPurchase = lazyPage(() => import("./dashboard/AssignClientPurchase"));
const MeetingRoom = lazyPage(() => import("./dashboard/MeetingRoom"));
const Meetings = lazyPage(() => import("./dashboard/Meeting"));
const StudentProfile = lazyPage(() => import("./dashboard/StudentProfile"));
const StudentEnrollment = lazyPage(() => import("./dashboard/StudentEnrollment"));
const PartnerProfileAdmin = lazyPage(() => import("./dashboard/PartnerProfile"));
const PartnerCommissions = lazyPage(() => import("./dashboard/PartnerCommissions"));
const CreateOnlineClass = lazyPage(() => import("./dashboard/CreateOnlineClass"));
const OnlineClasses = lazyPage(() => import("./dashboard/OnlineClasses"));
const StudentClassWaitingRoom = lazyPage(() => import("./studentdashboard/StudentClassWaitingRoom"));
const ClassMeeting = lazyPage(() => import("./dashboard/ClassMeeting"));
const Assignments = lazyPage(() => import("./dashboard/Assignments"));
const AllProducts = lazyPage(() => import("./pages/AllProducts"));
const AllCategories = lazyPage(() => import("./pages/AllCategories"));
const AllBusinesses = lazyPage(() => import("./pages/AllBusinesses"));
const AllCourses = lazyPage(() => import("./pages/AllCourses"));
const BusinessProfilePage = lazyPage(() => import("./pages/BusinessDetails"));
const FeaturedCourses = lazyPage(() => import("./pages/FeaturedCourses"));
const CourseDetailsPage = lazyPage(() => import("./pages/CourseDetails"));
const SearchPage = lazyPage(() => import("./pages/SearchPage"));
const Builder = lazyPage(() => import("./dashboard/Website/Builder"));
const PartnerLayout = lazyPage(() => import("./partnersdashboard/PartnerLayout"));
const Referrals = lazyPage(() => import("./partnersdashboard/Referrals"));
const Documents = lazyPage(() => import("./partnersdashboard/Documents"));
const StudentGroupsPage = lazyPage(() => import("./dashboard/StudentsGroups"));
const CommissionDetails = lazyPage(() => import("./partnersdashboard/CommissionsDetails"));
const ClientLayout = lazyPage(() => import("./clientsdashboard/ClientLayout"));
const CleintIndex = lazyPage(() => import("./clientsdashboard/Index"));
const CleintIvoices = lazyPage(() => import("./clientsdashboard/Invoices"));
const CleintMeetings = lazyPage(() => import("./clientsdashboard/Meetings"));
const CleintProfile = lazyPage(() => import("./clientsdashboard/Profile"));
const CleintPurchases = lazyPage(() => import("./clientsdashboard/Purchases"));
const CleintPayments = lazyPage(() => import("./clientsdashboard/Payments"));
const CleintNotifications = lazyPage(() => import("./clientsdashboard/Notifications"));
const PurchaseDetails = lazyPage(() => import("./clientsdashboard/PurchasesDetails"));
const PaymentDetails = lazyPage(() => import("./clientsdashboard/PaymentsDetails"));
const SubmitPayment = lazyPage(() => import("./clientsdashboard/SubmitPayment"));
const InvoiceDetails = lazyPage(() => import("./clientsdashboard/InvoiceDetails"));
const StudentLayout = lazyPage(() => import("./studentdashboard/StudentLayout"));
const StudentIndex = lazyPage(() => import("./studentdashboard/Index"));
const StudentEnrollments = lazyPage(() => import("./studentdashboard/Enrollments"));
const StudentAssignment = lazyPage(() => import("./studentdashboard/Assignments"));
const StudentCertificates = lazyPage(() => import("./studentdashboard/Certificates"));
const StuProfile = lazyPage(() => import("./studentdashboard/Profile"));
const StudentPayments = lazyPage(() => import("./studentdashboard/Payments"));
const StudentClasses = lazyPage(() => import("./studentdashboard/Classes"));
const StudentNotifications = lazyPage(() => import("./studentdashboard/Notifications"));
const EnrollmentDetails = lazyPage(() => import("./studentdashboard/EnrollmentsDetails"));
const ClassDetails = lazyPage(() => import("./studentdashboard/ClassDetails"));
const AssignmentDetails = lazyPage(() => import("./studentdashboard/AssignmentDetails"));
const StudentPaymentDetails = lazyPage(() => import("./studentdashboard/PaymentDetails"));
const CertificateDetails = lazyPage(() => import("./studentdashboard/CertificateDetails"));
const Appoint = lazyPage(() => import("./dashboard/Appoint"));
const PrivacyPolicy = lazyPage(() => import("./pages/PrivacyPolicy"));
const TermsConditions = lazyPage(() => import("./pages/Termsandconditions"));
const RefundPolicy = lazyPage(() => import("./pages/RefundPolicy"));
const CookiePolicy = lazyPage(() => import("./pages/Cookies"));
const Disclaimer = lazyPage(() => import("./pages/Disclaimer"));
const PaymentStatusPage = lazyPage(() => import("./pages/PaymentStatusPage"));
const MasterLoginPage = lazyPage(() => import("./pages/MasterLogin"));
const TenantsPage = lazyPage(() => import("./masterdashboard/Tenants"));
const TenantDetailsPage = lazyPage(() => import("./masterdashboard/TenantDetailsPage"));
const MasterUsersPage = lazyPage(() => import("./masterdashboard/Users"));
const MasterRolesPage = lazyPage(() => import("./masterdashboard/MasterRolesPage"));
const BillingPage = lazyPage(() => import("./masterdashboard/BillingPage"));
const SettingsPage = lazyPage(() => import("./masterdashboard/SettingsPage"));
const MasterCategoriesPage = lazyPage(() => import("./masterdashboard/MasterCategoriesPage"));
const MasterNotificationsPage = lazyPage(() => import("./masterdashboard/MasterNotificationsPage"));
const MasterActivityLogsPage = lazyPage(() => import("./masterdashboard/MasterActivityLogsPage"));
const BusinessIndustries = lazyPage(() => import("./masterdashboard/BusinessIndustries"));
const CourseCategories = lazyPage(() => import("./masterdashboard/CourseCategories"));
const TenantVerifications = lazyPage(() => import("./masterdashboard/TenantVerifications"));
const WebsitePages = lazyPage(() => import("./dashboard/Website/WebsitePages"));
const WebsitePreview = lazyPage(() => import("./dashboard/Website/WebsitePreview"));
const WebsiteSettings = lazyPage(() => import("./dashboard/Website/WebsiteSettings"));
const WebsiteMenus = lazyPage(() => import("./dashboard/Website/WebsiteMenus"));
const WebsiteAssets = lazyPage(() => import("./dashboard/Website/WebsiteAssets"));
const WebsiteForms = lazyPage(() => import("./dashboard/Website/WebsiteForms"));
const WebsiteFormBuilder = lazyPage(() => import("./dashboard/Website/WebsiteFormBuilder"));
const WebsiteContent = lazyPage(() => import("./dashboard/Website/WebsiteContent"));
const PublicWebsite = lazyPage(() => import("./dashboard/Website/PublicWebiste"));
const AdvertisingSection = lazyPage(() => import("./masterdashboard/AdvertisingSection"));
const Advertising = lazyPage(() => import("./dashboard/Advertising"));
const StaffTasks = lazyPage(() => import("./dashboard/StaffTasks"));
const BranchesPage = lazyPage(() => import("./dashboard/logic/master/Branches"));
const BrandsPage = lazyPage(() => import("./dashboard/logic/master/BrandsPage"));
const CategoriesPage = lazyPage(() => import("./dashboard/logic/master/CategoriesPage"));
const ColorsMasterPage = lazyPage(() => import("./dashboard/logic/master/ColorsPage"));
const SeasonsPage = lazyPage(() => import("./dashboard/logic/master/SeasonsPage"));
const TaxCatalogPage = lazyPage(() => import("./dashboard/logic/master/TaxCatelogPage"));
const SizeGroupsPage = lazyPage(() => import("./dashboard/logic/master/SizeGroupsPage"));
const SizesMasterPage = lazyPage(() => import("./dashboard/logic/master/SizesMasterPage"));
const StoresPage = lazyPage(() => import("./dashboard/logic/master/StoresPage"));
const SubCategoriesPage = lazyPage(() => import("./dashboard/logic/master/SubCategoriesPage"));
const SuppliersPage = lazyPage(() => import("./dashboard/logic/master/SuppliersPage"));
const UnitsMasterPage = lazyPage(() => import("./dashboard/logic/master/UnitsMasterPage"));
const PromotionsPage = lazyPage(() => import("./dashboard/logic/master/PromotionsPage"));
const MasterProductsPage = lazyPage(() => import("./dashboard/logic/master/products/ProductsPage"));
const ProductsForm = lazyPage(() => import("./dashboard/logic/master/products/ProductsForm"));
const ProductsDetails = lazyPage(() => import("./dashboard/logic/master/products/ProductsDetails"));
const ProductsEditPage = lazyPage(() => import("./dashboard/logic/master/products/ProductsEditPage"));
const StockTransferManagementPage = lazyPage(() => import("./dashboard/logic/inventory/StockTransferManagementPage"));
const LowStock = lazyPage(() => import("./dashboard/logic/inventory/LowStock"));
const StockAdjustment = lazyPage(() => import("./dashboard/logic/inventory/StockAdjustment"));
const StockCount = lazyPage(() => import("./dashboard/logic/inventory/StockCount"));
const StockLedger = lazyPage(() => import("./dashboard/logic/inventory/StockLedger"));
const StockTransferPage = lazyPage(() => import("./dashboard/logic/inventory/StockTransfer"));
const StockValuationPage = lazyPage(() => import("./dashboard/logic/inventory/StockValuationPage"));
const PurchaseOrdersPage = lazyPage(() => import("./dashboard/logic/purchases/PurchaseOrders"));
const CreatePurchaseOrderPage = lazyPage(() => import("./dashboard/logic/purchases/CreatePurchaseOrder"));
const PurchaseOrderDetailsPage = lazyPage(() => import("./dashboard/logic/purchases/PurchaseOrderDetails"));
const GRNListPage = lazyPage(() => import("./dashboard/logic/purchases/GRNList"));
const GRNDetailsPage = lazyPage(() => import("./dashboard/logic/purchases/GRNDetailsPage"));
const GRNCreatePage = lazyPage(() => import("./dashboard/logic/purchases/GRNCreatePage"));
const SupplierReturnsPage = lazyPage(() => import("./dashboard/logic/purchases/SupplierReturnsPage"));
const CreateSupplierReturnPage = lazyPage(() => import("./dashboard/logic/purchases/CreateSupplierReturn"));
const SupplierReturnDetailsPage = lazyPage(() => import("./dashboard/logic/purchases/SupplierReturnDetails"));
const CreditNoteDetails = lazyPage(() => import("./dashboard/logic/sales/returns/CreditNoteDetails"));
const CreditNotesList = lazyPage(() => import("./dashboard/logic/sales/returns/CreditNotesList"));
const SalesReturnDetails = lazyPage(() => import("./dashboard/logic/sales/returns/SalesReturnDetails"));
const CreateSalesReturn = lazyPage(() => import("./dashboard/logic/sales/returns/CreateSalesReturn"));
const SalesReturnsList = lazyPage(() => import("./dashboard/logic/sales/returns/SalesReturnsList"));
const ReceivePayment = lazyPage(() => import("./dashboard/logic/sales/salesinvoice/ReceivePayment"));
const SalesInvoiceDetails = lazyPage(() => import("./dashboard/logic/sales/salesinvoice/SalesInvoiceDetails"));
const SalesInvoiceList = lazyPage(() => import("./dashboard/logic/sales/salesinvoice/SalesInvoiceList"));
const SalesOrderDetails = lazyPage(() => import("./dashboard/logic/sales/SalesOrderDetails"));
const SalesOrderList = lazyPage(() => import("./dashboard/logic/sales/SalesOrderList"));
const CreateSalesOrder = lazyPage(() => import("./dashboard/logic/sales/CreateSalesOrder"));
const CustomersPage = lazyPage(() => import("./dashboard/logic/sales/customers/CustomersPage"));
const EcommerceOrdersPage = lazyPage(() => import("./dashboard/logic/sales/EcommerceOrdersPage"));
const CustomerDetail = lazyPage(() => import("./dashboard/logic/sales/customers/CustomerDetail"));
const DeliveryChallanList = lazyPage(() => import("./dashboard/logic/sales/dispatch/DeliveryChallanList"));
const CreateDeliveryChallan = lazyPage(() => import("./dashboard/logic/sales/dispatch/CreateDeliveryChallan"));
const DeliveryChallanDetails = lazyPage(() => import("./dashboard/logic/sales/dispatch/DeliveryChallanDetails"));
const GSTReports = lazyPage(() => import("./dashboard/logic/reports/GSTAnalytics"));
const AttendanceReports = lazyPage(() => import("./dashboard/logic/reports/AttendanceAnalytics"));
const EmployeeAnalytics = lazyPage(() => import("./dashboard/logic/reports/EmployeeAnalytics"));
const PayrollAnalytics = lazyPage(() => import("./dashboard/logic/reports/PayrollAnalytics"));
const FinanceReports = lazyPage(() => import("./dashboard/logic/reports/FinanceAnalytics"));
const POSReports = lazyPage(() => import("./dashboard/logic/reports/POSAnalytics"));
const PurchaseReports = lazyPage(() => import("./dashboard/logic/reports/PurchaseAnalytics"));
const InventoryReports = lazyPage(() => import("./dashboard/logic/reports/InventoryAnalytics"));
const CustomerReports = lazyPage(() => import("./dashboard/logic/reports/CustomerAnalytics"));
const BrandClaimReport = lazyPage(() => import("./dashboard/logic/reports/BrandClaimAnalytics"));
const SalesReport = lazyPage(() => import("./dashboard/logic/reports/SalesAnalytics"));
const DailyAttendance = lazyPage(() => import("./dashboard/logic/attendance/DailyAttendance"));
const MonthlyAttendance = lazyPage(() => import("./dashboard/logic/attendance/MonthlyAttendance"));
const AttendanceCorrections = lazyPage(() => import("./dashboard/logic/attendance/AttendanceCorrections"));
const HrmsAttendance = lazyPage(() => import("./dashboard/logic/attendance/Attendance"));
const EmployeeList = lazyPage(() => import("./dashboard/logic/employee/EmployeeList"));
const AddEmployee = lazyPage(() => import("./dashboard/logic/employee/AddEmployee"));
const EmployeeDetails = lazyPage(() => import("./dashboard/logic/employee/EmployeeDetails"));
const EditEmployee = lazyPage(() => import("./dashboard/logic/employee/EditEmployee"));
const Payroll = lazyPage(() => import("./dashboard/logic/payroll/Payroll"));
const GeneratePayroll = lazyPage(() => import("./dashboard/logic/payroll/GeneratePayroll"));
const GenerateOffCyclePayroll = lazyPage(() => import("./dashboard/logic/payroll/GenerateOffCyclePayroll"));
const Payslips = lazyPage(() => import("./dashboard/logic/payroll/Payslips"));
const PayslipDetails = lazyPage(() => import("./dashboard/logic/payroll/PaySlipDetails"));
const LeaveRequests = lazyPage(() => import("./dashboard/logic/leave/LeaveRequests"));
const ApplyLeave = lazyPage(() => import("./dashboard/logic/leave/ApplyLeave"));
const LeaveDetails = lazyPage(() => import("./dashboard/logic/leave/LeaveDetails"));
const LeaveBalance = lazyPage(() => import("./dashboard/logic/leave/LeaveBalance"));
const LeaveTypes = lazyPage(() => import("./dashboard/logic/leave/LeaveTypes"));
const POS = lazyPage(() => import("./dashboard/logic/pos/POS"));
const PosCountersPage = lazyPage(() => import("./dashboard/logic/pos/counters/PosCountersPage"));
const Franchise = lazyPage(() => import("./dashboard/franchise/Index"));
const FranchiseTypes = lazyPage(() => import("./masterdashboard/franchise/FranchiseTypes"));
const FranchiseTree = lazyPage(() => import("./masterdashboard/franchise/FranchiseTree"));
const FranchiseHolders = lazyPage(() => import("./masterdashboard/franchise/FranchiseHolders"));
const FranchiseReferrals = lazyPage(() => import("./masterdashboard/franchise/FranchiseReferrals"));
const FranchiseCommissions = lazyPage(() => import("./masterdashboard/franchise/FranchiseCommissions"));
const FranchiseTerritories = lazyPage(() => import("./masterdashboard/franchise/FranchiseTerritories"));
const FranchiseApplications = lazyPage(() => import("./masterdashboard/franchise/FranchiseApplications"));
const PosLoginPage = lazyPage(() => import("./pages/PosLoginPage"));
const AssociationsMasterDashboard = lazyPage(() => import("./masterdashboard/MasterAssociation"));
const CompanyProfilePage = lazyPage(() => import("./dashboard/CompanyProfilePage"));
const EventsPage = lazyPage(() => import("./dashboard/events/EventsPage"));
const EventDetailsPage = lazyPage(() => import("./dashboard/events/EventDetailsPage"));
const PublicEventGallery = lazyPage(() => import("./pages/PublicEventGallery"));
const PublicEventInvitation = lazyPage(() => import("./pages/PublicEventInvitation"));
const EventGalleryDesignPage = lazyPage(() => import("./dashboard/events/EventGalleryDesignPage"));

function AppWrapper() {
  const location = useLocation();
  const isAdminDashboard = location.pathname.startsWith("/admindashboard");
  const isTenantDashboard = isAdminDashboard || location.pathname === "/pos" || location.pathname.startsWith("/pos/");
  const isDashboardUi = isDashboardAppearance(location.pathname);
  const { tenant } = useContext(AuthContext);

  useBranding(tenant, isTenantDashboard);

  return (
    <div className={`${isTenantDashboard ? "tenant-dashboard" : ""} ${isDashboardUi ? "dashboard-ui" : ""} text-secondary min-h-screen flex flex-col font-brand`}>
      <main className="flex-grow">
        <ScrollToTop />
        <TenantAccessBoundary><Routes>
          <Route path="/register/:id" element={<PublicRegistration />} />
          <Route path="/event-invite/:slug" element={<PublicEventInvitation />} />
          <Route element={<MarketplaceLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/product/:slug" element={<ProductDetails />} />
            <Route path="/course/:slug" element={<CourseDetailsPage />} />
            <Route path="/business/:id" element={<BusinessProfilePage />} />
            {/* <Route path="/category/:category" element={<CategoryPage />} /> */}
            {/* <Route path="/search" element={<SearchPage />} /> */}
            <Route path="/search" element={<SearchPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<AllProducts />} />
            <Route path="/categories" element={<AllCategories />} />
            <Route path="/businesses" element={<AllBusinesses />} />
            <Route path="/courses" element={<AllCourses />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/payment-status" element={<PaymentStatusPage />} />
          </Route>

          <Route
            path="/event-invitation/:token"
            element={<PublicEventInvitation />}
          />
          <Route
            path="/event-gallery/:eventSlug/:shareSlug"
            element={<PublicEventGallery />}
          />

          <Route path="/event-gallery/:slug" element={<PublicEventGallery />} />
          <Route path="/site/:tenant/*" element={<PublicWebsite />} />
          <Route path="/register" element={<AdminRegister />} />
          <Route path="/login" element={<AdminLoginPage />} />
          <Route path="/pos/login" element={<PosLoginPage />} />
          <Route path="/userlogin" element={<UserLoginPage />} />
          <Route path="/master/login" element={<MasterLoginPage />} />
          <Route element={<MasterProtectedRoute />}>
            <Route element={<MasterLayout />}>
              <Route path="/masterdashboard" element={<Home />} />
              <Route path="/masterdashboard/invitation-catalog" element={<InvitationCatalog />} />
              <Route path="/masterdashboard/system-health" element={<SystemHealth />} />
              <Route path="/masterdashboard/analytics" element={<Analytics />} />
              <Route path="/masterdashboard/approvals" element={<ApprovalInboxPage />} />
              <Route
                path="/masterdashboard/tenants"
                element={<TenantsPage />}
              />
              <Route
                path="/masterdashboard/tenants/:id"
                element={<TenantDetailsPage />}
              />
              <Route path="/masterdashboard/plans" element={<Plans />} />
              <Route
                path="/masterdashboard/users"
                element={<MasterUsersPage />}
              />
              <Route
                path="/masterdashboard/roles"
                element={<MasterRolesPage />}
              />
              <Route
                path="/masterdashboard/categories"
                element={<MasterCategoriesPage />}
              />
              <Route
                path="/masterdashboard/billing"
                element={<BillingPage />}
              />
              <Route
                path="/masterdashboard/settings"
                element={<SettingsPage />}
              />
              <Route
                path="/masterdashboard/notifications"
                element={<MasterNotificationsPage />}
              />

              <Route
                path="/masterdashboard/activity-logs"
                element={<MasterActivityLogsPage />}
              />
              <Route
                path="/masterdashboard/business-industries"
                element={<BusinessIndustries />}
              />
              <Route
                path="/masterdashboard/course-categories"
                element={<CourseCategories />}
              />
              <Route
                path="/masterdashboard/tenant-verifications"
                element={<TenantVerifications />}
              />
              <Route
                path="/masterdashboard/advertising"
                element={<AdvertisingSection />}
              />
              <Route
                path="/masterdashboard/franchise/types"
                element={<FranchiseTypes />}
              />
              <Route
                path="/masterdashboard/franchise/tree"
                element={<FranchiseTree />}
              />
              <Route
                path="/masterdashboard/franchise/holders"
                element={<FranchiseHolders />}
              />
              <Route
                path="/masterdashboard/franchise/referrals"
                element={<FranchiseReferrals />}
              />
              <Route
                path="/masterdashboard/franchise/commissions"
                element={<FranchiseCommissions />}
              />
              <Route
                path="/masterdashboard/franchise/territories"
                element={<FranchiseTerritories />}
              />
              <Route
                path="/masterdashboard/franchise/applications"
                element={<FranchiseApplications />}
              />
              <Route
                path="/masterdashboard/associations"
                element={<AssociationsMasterDashboard />}
              />
            </Route>
          </Route>
          <Route
            path="/admindashboard"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Index />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/events"
            element={
              <ProtectedRoute>
                <EventsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/events/:id"
            element={
              <ProtectedRoute>
                <EventDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/events/:id/galleries/:galleryId/design"
            element={
              <ProtectedRoute>
                <EventGalleryDesignPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/franchise"
            element={
              <ProtectedRoute>
                <Franchise />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/advertising"
            element={
              <ProtectedRoute>
                <Advertising />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/advertising/payment-status"
            element={
              <ProtectedRoute>
                <Advertising />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/appointments"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Appoint />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/builder"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Builder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/pages"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsitePages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/settings"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsiteSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/menus"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsiteMenus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/assets"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsiteAssets />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/forms"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsiteForms />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/forms/:id/builder"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsiteFormBuilder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/content"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsiteContent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/website/preview/:slug"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <WebsitePreview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/client-enrollments"
            element={<ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}><ClientEnrollments /></ProtectedRoute>}
          />
          <Route
            path="/admindashboard/clients/:clientId/purchase"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <AssignPurchase />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/students/:studentId/enroll"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <StudentEnrollment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/clients/:id/profile"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <ClientProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/students/:id/profile"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <StudentProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/meetings"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Meetings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/meetings/:id/room"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <MeetingRoom />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/products/search"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <SearchProducts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/analytics"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Analyticsmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/marketplace/products/:id"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <ProductDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/products/incomingreferrals"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <IncomingReferrals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/products/referrals"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <MyReferrals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/assignments"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Assignments />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/admindashboard/association/:id"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <BNIPage />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/admindashboard/tasks"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Tasks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/my-tasks"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <StaffTasks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounts/profit-loss"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <ProfitLoss />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounts/ledger"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Ledger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounts/balance-sheet"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Balancesheet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounts/expenses"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Expenses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounts/tax"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <Tax />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounts/reports"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "admin", "staff"]}>
                <AccountReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/certificates"
            element={
              <ProtectedRoute>
                <Certificates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/calls"
            element={
              <ProtectedRoute>
                <Calllog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/leads"
            element={
              <ProtectedRoute>
                <Appointments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/leads/new"
            element={
              <ProtectedRoute>
                <AddLead />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/leads/form-builder"
            element={
              <ProtectedRoute>
                <LeadFormBuilder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route path="/admindashboard/courses/:id" element={<ProtectedRoute><FeatureRouteProtection feature="COURSES"><TenantCourseDetailsPage /></FeatureRouteProtection></ProtectedRoute>} />
          <Route
            path="/admindashboard/courses"
            element={
              <ProtectedRoute>
                <Courses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/associations/:associationId"
            element={
              <ProtectedRoute>
                <BNIPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/marketplace/company/:id"
            element={
              <ProtectedRoute>
                <CompanyProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/clients"
            element={
              <ProtectedRoute>
                <Clients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/registrations"
            element={
              <ProtectedRoute>
                <Registrations />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/admindashboard/createmeetings"
            element={<CreateMeeting />}
          /> */}
          {/* <Route
            path="/admindashboard/clientprofile/:id"
            element={
              <ProtectedRoute>
                <ClientProfile />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/admindashboard/partners"
            element={
              <ProtectedRoute>
                <Partners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/partners/:partnerId/profile"
            element={
              <ProtectedRoute>
                <PartnerProfileAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/partners/commissions"
            element={
              <ProtectedRoute>
                <PartnerCommissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/onlineclass/create"
            element={
              <ProtectedRoute>
                <CreateOnlineClass />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/onlineclass"
            element={
              <ProtectedRoute>
                <OnlineClasses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/onlineclass/:id/join"
            element={
              <ProtectedRoute>
                <ClassMeeting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/partners/association"
            element={
              <ProtectedRoute>
                <AssociatePartners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/staff"
            element={
              <ProtectedRoute>
                <Staff />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/departments"
            element={
              <ProtectedRoute>
                <Departments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/positions"
            element={
              <ProtectedRoute>
                <Positions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/roles"
            element={
              <ProtectedRoute>
                <Roles />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/students"
            element={
              <ProtectedRoute>
                <Students />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/students/groups"
            element={
              <ProtectedRoute>
                <StudentGroupsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/payments"
            element={
              <ProtectedRoute>
                <Payments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/invoices"
            element={
              <ProtectedRoute>
                <AdminInvoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/attendance"
            element={
              <ProtectedRoute>
                <Attendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/notifications"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/staffattendance"
            element={
              <ProtectedRoute>
                <StaffAttendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/profile"
            element={
              <ProtectedRoute>
                <AdminProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/branches"
            element={
              <ProtectedRoute>
                <BranchesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/brands"
            element={
              <ProtectedRoute>
                <BrandsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/categories"
            element={
              <ProtectedRoute>
                <CategoriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/colors"
            element={
              <ProtectedRoute>
                <ColorsMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/seasons"
            element={
              <ProtectedRoute>
                <SeasonsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/hsn-gst"
            element={
              <ProtectedRoute>
                <TaxCatalogPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/sizegroup"
            element={
              <ProtectedRoute>
                <SizeGroupsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/sizes"
            element={
              <ProtectedRoute>
                <SizesMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/stores"
            element={
              <ProtectedRoute>
                <StoresPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/subcategories"
            element={
              <ProtectedRoute>
                <SubCategoriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/suppliers"
            element={
              <ProtectedRoute>
                <SuppliersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/units"
            element={
              <ProtectedRoute>
                <UnitsMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/promotions"
            element={
              <ProtectedRoute>
                <PromotionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/products"
            element={
              <ProtectedRoute>
                <MasterProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/products/add"
            element={
              <ProtectedRoute>
                <ProductsForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/products/:id"
            element={
              <ProtectedRoute>
                <ProductsDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/masters/products/:id/edit"
            element={
              <ProtectedRoute>
                <ProductsEditPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/inventory/adjustment"
            element={
              <ProtectedRoute>
                <StockAdjustment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/inventory/ledger"
            element={
              <ProtectedRoute>
                <StockLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/inventory/transfers"
            element={
              <ProtectedRoute>
                <StockTransferManagementPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/inventory/transfers/create"
            element={
              <ProtectedRoute>
                <StockTransferPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/inventory/count"
            element={
              <ProtectedRoute>
                <StockCount />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/inventory/low-stock"
            element={
              <ProtectedRoute>
                <LowStock />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/inventory/valuation"
            element={
              <ProtectedRoute>
                <StockValuationPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/purchases/orders"
            element={
              <ProtectedRoute>
                <PurchaseOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/create"
            element={
              <ProtectedRoute>
                <CreatePurchaseOrderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/:id"
            element={
              <ProtectedRoute>
                <PurchaseOrderDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/grn"
            element={
              <ProtectedRoute>
                <GRNListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/grn/:id"
            element={
              <ProtectedRoute>
                <GRNDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/grn/create"
            element={
              <ProtectedRoute>
                <GRNCreatePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/returns"
            element={
              <ProtectedRoute>
                <SupplierReturnsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/returns/create"
            element={
              <ProtectedRoute>
                <CreateSupplierReturnPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/purchases/returns/:id"
            element={
              <ProtectedRoute>
                <SupplierReturnDetailsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/sales/ecommerce-orders"
            element={
              <ProtectedRoute>
                <EcommerceOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/customers"
            element={
              <ProtectedRoute>
                <CustomersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/customers/:id"
            element={
              <ProtectedRoute>
                <CustomerDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/orders/create"
            element={
              <ProtectedRoute>
                <CreateSalesOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/orders/list"
            element={
              <ProtectedRoute>
                <SalesOrderList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/orders/:id"
            element={
              <ProtectedRoute>
                <SalesOrderDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/delivery/challan/list"
            element={
              <ProtectedRoute>
                <DeliveryChallanList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/delivery/challan/create"
            element={
              <ProtectedRoute>
                <CreateDeliveryChallan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/delivery/challan/:id"
            element={
              <ProtectedRoute>
                <DeliveryChallanDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/invoice/list"
            element={
              <ProtectedRoute>
                <SalesInvoiceList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/invoice/:id"
            element={
              <ProtectedRoute>
                <SalesInvoiceDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/payment"
            element={
              <ProtectedRoute>
                <ReceivePayment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/sales/returns"
            element={
              <ProtectedRoute>
                <SalesReturnsList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/sales/returns/create"
            element={
              <ProtectedRoute>
                <CreateSalesReturn />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/sales/returns/:id"
            element={
              <ProtectedRoute>
                <SalesReturnDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/sales/credit-notes"
            element={
              <ProtectedRoute>
                <CreditNotesList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/sales/credit-notes/:id"
            element={
              <ProtectedRoute>
                <CreditNoteDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/reports/sales"
            element={
              <ProtectedRoute>
                <SalesReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/customsales"
            element={
              <ProtectedRoute>
                <BrandClaimReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/customers"
            element={
              <ProtectedRoute>
                <CustomerReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/inventory"
            element={
              <ProtectedRoute>
                <InventoryReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/purchases"
            element={
              <ProtectedRoute>
                <PurchaseReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/pos"
            element={
              <ProtectedRoute>
                <POSReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/finance"
            element={
              <ProtectedRoute>
                <FinanceReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/gst"
            element={
              <ProtectedRoute>
                <GSTReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/attendance"
            element={
              <ProtectedRoute>
                <AttendanceReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/payroll"
            element={
              <ProtectedRoute>
                <PayrollAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/reports/employee"
            element={
              <ProtectedRoute>
                <EmployeeAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/attendance/daily"
            element={
              <ProtectedRoute>
                <DailyAttendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/attendance/monthly"
            element={
              <ProtectedRoute>
                <MonthlyAttendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/attendance/corrections"
            element={
              <ProtectedRoute>
                <AttendanceCorrections />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/attendance"
            element={
              <ProtectedRoute>
                <HrmsAttendance />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/hrms/employees"
            element={
              <ProtectedRoute>
                <EmployeeList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/employees/add"
            element={
              <ProtectedRoute>
                <AddEmployee />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/employees/:id"
            element={
              <ProtectedRoute>
                <EmployeeDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/employees/:id/edit"
            element={
              <ProtectedRoute>
                <EditEmployee />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/hrms/payroll"
            element={
              <ProtectedRoute>
                <Payroll />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/payroll/generate"
            element={
              <ProtectedRoute>
                <GeneratePayroll />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/payroll/off-cycle"
            element={
              <ProtectedRoute>
                <GenerateOffCyclePayroll />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/payroll/payslips"
            element={
              <ProtectedRoute>
                <Payslips />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/payroll/payslips/:id"
            element={
              <ProtectedRoute>
                <PayslipDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/hrms/leave"
            element={
              <ProtectedRoute>
                <LeaveRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/leave/apply"
            element={
              <ProtectedRoute>
                <ApplyLeave />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/leave/requests/:id"
            element={
              <ProtectedRoute>
                <LeaveDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/leave/balance"
            element={
              <ProtectedRoute>
                <LeaveBalance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/hrms/leave/types"
            element={
              <ProtectedRoute>
                <LeaveTypes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pos"
            element={
              <ProtectedRoute>
                <POS />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/pos/counters"
            element={
              <ProtectedRoute>
                <PosCountersPage />
              </ProtectedRoute>
            }
          />

          <Route element={<PartnerLayout />}>
            <Route
              path="/partnerdashboard"
              element={
                <ProtectedRoute>
                  <PartnerHome />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partnerdashboard/referrals"
              element={
                <ProtectedRoute>
                  <Referrals />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partnerdashboard/documents"
              element={
                <ProtectedRoute>
                  <Documents />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partnerdashboard/profile"
              element={
                <ProtectedRoute>
                  <PartnerProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partnerdashboard/commissions"
              element={
                <ProtectedRoute>
                  <PartnerPayments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partnerdashboard/notifications"
              element={
                <ProtectedRoute>
                  <PartnerNotifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partnerdashboard/commissions/:id"
              element={
                <ProtectedRoute>
                  <CommissionDetails />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route element={<ClientLayout />}>
            <Route
              path="/clientdashboard"
              element={
                <ProtectedRoute>
                  <CleintIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/meetings"
              element={
                <ProtectedRoute>
                  <CleintMeetings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/profile"
              element={
                <ProtectedRoute>
                  <CleintProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/invoices"
              element={
                <ProtectedRoute>
                  <CleintIvoices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/invoices/:id"
              element={
                <ProtectedRoute>
                  <InvoiceDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/notifications"
              element={
                <ProtectedRoute>
                  <CleintNotifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/payments"
              element={
                <ProtectedRoute>
                  <CleintPayments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/payments/:id"
              element={
                <ProtectedRoute>
                  <PaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/payments/new"
              element={
                <ProtectedRoute>
                  <SubmitPayment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/purchases"
              element={
                <ProtectedRoute>
                  <CleintPurchases />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientdashboard/purchases/:id"
              element={
                <ProtectedRoute>
                  <PurchaseDetails />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route element={<StudentLayout />}>
            <Route
              path="/studentdashboard"
              element={
                <ProtectedRoute>
                  <StudentIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/enrollments"
              element={
                <ProtectedRoute>
                  <StudentEnrollments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/enrollments/:id"
              element={
                <ProtectedRoute>
                  <EnrollmentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/classes"
              element={
                <ProtectedRoute>
                  <StudentClasses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/classes/:id"
              element={
                <ProtectedRoute>
                  <ClassDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/classes/:id/waiting"
              element={
                <ProtectedRoute>
                  <StudentClassWaitingRoom />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/assignments"
              element={
                <ProtectedRoute>
                  <StudentAssignment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/assignments/:id"
              element={
                <ProtectedRoute>
                  <AssignmentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/payments"
              element={
                <ProtectedRoute>
                  <StudentPayments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/payments/:id"
              element={
                <ProtectedRoute>
                  <StudentPaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/certificates"
              element={
                <ProtectedRoute>
                  <StudentCertificates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/certificates/:id"
              element={
                <ProtectedRoute>
                  <CertificateDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/notifications"
              element={
                <ProtectedRoute>
                  <StudentNotifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studentdashboard/profile"
              element={
                <ProtectedRoute>
                  <StuProfile />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes></TenantAccessBoundary>
      </main>
      {/* {isAdminDashboard && <ChatWidget />} */}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

